export const dictionary = {
  en: 'English speaking welcome',
  //nl: 'Dutch',
}
